import { useMemo } from 'react';
import { type LeaseSettingsPayload } from '../../../../../../api/types';
import { type VariantOption } from '../../../shared/useSelectedVariants';
import { type LeaseTableRecord } from './shared';

const useRecords = (
    variants: VariantOption[],
    leaseSettings: LeaseSettingsPayload,
    terms: number[]
): LeaseTableRecord[] =>
    useMemo<LeaseTableRecord[]>(() => {
        if (!leaseSettings || !terms?.length || !variants?.length) {
            return [];
        }

        const { type, table } = leaseSettings;

        if (type !== 'table') {
            return [];
        }

        const getValue = (variantSuiteId: string, term: number) => {
            const row = table.find(row => row.variantSuiteId === variantSuiteId && row.term === term);

            return row?.value;
        };

        const results: LeaseTableRecord[] = variants.map(variant => {
            const termsValue = {};
            terms.forEach(term => {
                termsValue[`term${term}`] = getValue(variant.id, term);
            });

            return {
                key: variant.id,
                variantSuiteId: variant.id,
                variantId: variant.identifier,
                variantName: `${variant.name} (${variant.identifier})`,
                variantNameFromParameter: `${variant.name} (${variant.identifier})`,
                ...termsValue,
            };
        });

        return results;
    }, [variants, leaseSettings, terms]);

export default useRecords;
